export default "__VITE_ASSET__d51331c5__"